import { Theme, ThemeProvider, Typography } from "@mui/material";
import { BarragemData } from "../../context";
import { HidroLayer, HidroLayerGroup } from "../mapa";
import { googleSateliteHybrid } from "../mapa/tiles";
import { divIcon, Marker } from "leaflet";
import { GeomBarragem } from "./geomBarragem";

export const barragemLayers = (barragem: BarragemData, theme: Theme, insertTile = true): HidroLayerGroup => {
  const contrastText = theme.palette.getContrastText(theme.palette.background.paper);

  const tileLayer = googleSateliteHybrid();
  const tile = new HidroLayer({ name: "Google Satelite Hybrid", showing: true, layer: tileLayer });

  if (!barragem.geometries.length) {
    return new HidroLayerGroup({ name: barragem.nome, showing: true, layers: [tile] });
  }

  const group = new HidroLayerGroup({ name: barragem.nome, showing: true, layers: [] });
  const heightGeom = 50;
  const iconSizeGeom = 20;

  const layerName = new Marker([barragem.lat, barragem.lon]);

  const component: JSX.Element = (
    <ThemeProvider theme={theme}>
      <div style={{
        height: `${heightGeom}px`,
        width: "250px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      }}>
        <Typography
          color="background.paper"
          sx={{ textShadow: `2px 2px 6px ${contrastText}` }}>
          {barragem.nome}
        </Typography>
      </div>
    </ThemeProvider>
  );

  const icon = divIcon({
    html: window.JSXToHTML(component),
    className: 'custom-svg-icon',
    iconAnchor: [iconSizeGeom / 2, heightGeom / 2],
  });

  layerName.setIcon(icon);
  group.push(new HidroLayer({ name: barragem.nome, showing: true, layer: layerName }));

  for (const geom of barragem.geometries) {
    const layer = new GeomBarragem([geom.lat, geom.lon], geom, theme.palette.geometries.geomBarragem);
    group.push(new HidroLayer({ name: geom.tipo, showing: true, layer: layer }));
  }

  if (insertTile) group.push(tile);

  return group;
};